import { connect } from 'react-redux';
import {
  clearRoute,
  importRoute,
  importRoster,
  removeTourManager,
  sendToTourManager,
  requestTourManagers,
} from '../modules/tour';

import TourOverviewTab from './TourOverviewTab';

const mapDispatchToProps = {
  importRoute,
  importRoster,
  clearRoute,
  removeTourManager,
  sendToTourManager,
  requestTourManagers,
};

const mapStateToProps = state => ({
  tour: state.tours.selectedTour.tour,
  rosterIsProcessing: state.tours.selectedTour.rosterIsProcessing,
  routeIsProcessing: state.tours.selectedTour.routeIsProcessing,
  tourManagers: state.tours.tourManagers,
});
const TourOverviewTabContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(TourOverviewTab);
export default TourOverviewTabContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/TourOverviewTabContainer.js